import { Signup } from './signup'
import { Classes } from './classes'
import { Notifications } from './notifications'
import { Zoom } from './zoom'
import { Admin } from './admin'
import { Auth } from './auth'

export const CloudFunctions = {
  Signup,
  Classes,
  Notifications,
  Zoom,
  Admin,
  Auth,
} as const
